import { MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publicationId: string;
    isVisible: boolean;
    onClose: (success: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const DoHidePublication: React.FC<IProps> = (props) => {

    const { publicationId, isVisible, onClose } = props;
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();

    const [saving, setSaving] = React.useState<boolean>(false);

    ///
    const hidePublication = () => {
        setSaving(true);
        api.v1.knowledgePublication.hidePublication({ publicationId })
            .then((result) => {
                if (result.data === true) {
                    if (isVisible) enqueueSnackbar(t("Feed.Card.Actions.DoHidePublication.HideSuccessMessage"), { variant: "success" });
                    else enqueueSnackbar(t("Feed.Card.Actions.DoHidePublication.ShowSuccessMessage"), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Feed.Card.Actions.DoHidePublication.SaveFailMessage"), { variant: "error" });
                    onClose(false);
                }
            })
            .catch(e => {
                MprcRequestSnackbarErrorReport(e);
                onClose(false);
            })
            .finally(() => {
                setSaving(false);
            });
    };

    useEffect(() => {
        hidePublication();
    }, []);

    return <MprcRequestIndicator type={"post"} visible={saving} />;
};
